var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckButtonTheme } from '../../enums';
import { IconCheckButton } from '../../icons';
import { typographyPx } from '../../typographyPx';
import { useState } from 'react';
import { BreadcrumbStyled, StepIndicatorStyles } from './StepIndicatorStyles';
var LabelSmall = typographyPx.labelSmall;
export var StepIndicator = function (_a) {
    var _b = _a.steps, steps = _b === void 0 ? ['1', '2', '3', '4'] : _b, preFilledStep = _a.preFilledStep, _c = _a.buttonTheme, buttonTheme = _c === void 0 ? CheckButtonTheme.Dark : _c, className = _a.className, onClick = _a.onClick, validateOnClick = _a.validateOnClick;
    var _d = useState(steps.indexOf(preFilledStep || '') || 0), selected = _d[0], setSelected = _d[1];
    var handleStepClick = function (step, index) {
        if (validateOnClick) {
            var valid = validateOnClick(step);
            valid && setSelected(index);
        }
        else {
            setSelected(index);
            onClick && onClick(step);
        }
    };
    return (_jsxs(StepIndicatorStyles, __assign({ buttonTheme: buttonTheme, className: className }, { children: [_jsx("div", __assign({ className: "step-wrapper" }, { children: steps.map(function (step, i) {
                    var isSelected = i === selected;
                    var clickable = steps.indexOf(step) <= selected + 1 && !isSelected;
                    var status = isSelected ? 'inprogress' : i < selected ? 'complete' : false;
                    return (_jsx(BreadcrumbStyled, __assign({ clickable: clickable }, { children: _jsx("div", __assign({ className: "breadcrumb-wrapper" }, { children: _jsxs("div", __assign({ className: "breadcrumb-container" }, { children: [_jsx("div", __assign({ className: "breadcrumb", onClick: function () { return clickable && handleStepClick(step, i); } }, { children: _jsx(IconCheckButton, { status: status, iconFill: null, backgroundFill: null, buttonTheme: buttonTheme }) })), i < steps.length - 1 && _jsx("div", { className: "divider" })] })) })) })));
                }) })), _jsx("div", __assign({ className: "name-wrapper" }, { children: steps.map(function (step, i) {
                    var clickable = steps.indexOf(step) <= selected + 1 && i !== selected;
                    return (_jsx(BreadcrumbStyled, __assign({ clickable: clickable }, { children: _jsx(LabelSmall, __assign({ onClick: function () { return clickable && handleStepClick(step, i); }, className: "stage-title" }, { children: step })) })));
                }) }))] })));
};
